const APP = "APP";

export const APP_READY = `${APP}:READY`;
export const USER_LOGIN = `USER_LOGIN`;
export const SET_FLAG = `${APP}:SET_FLAG`;
export const CLIENT_SEARCH_PAGE_ENTER = `CLIENT_SEARCH_PAGE_ENTER`;
export const CLIENT_SEARCH_PAGE_LEAVE = `CLIENT_SEARCH_PAGE_LEAVE`;
export const CALLCENTER_WORKFLOW_MOUNTED = `${APP}:CALLCENTER_WORKFLOW_MOUNTED`;
export const ROUTER_CACHE_RESTORED = `${APP}:ROUTER_CACHE_RESTORED`;

// functions that generate history.push arguments
export const ROUTES = {
  MAIN_PAGE: () => "/",
  AUTH_PAGE: () => "/auth/login",
  PROCESSING: () => "/processing",
  PROCESSING_COMPANIES: ({ search, state } = {}) => ({
    pathname: "/processing/companies",
    search,
    state,
  }),
  PROCESSING_MERCHANTS: ({ search, state } = {}) => ({
    pathname: "/processing/merchants",
    search,
    state,
  }),
  PROCESSING_TERMINALS: ({ search, state } = {}) => ({
    pathname: "/processing/terminals",
    search,
    state,
  }),
  PROCESSING_TRANSACTION: ({ search, state } = {}) => ({
    pathname: "/processing/transactions",
    search,
    state,
  }),
  CALLCENTER: () => "/callcenter",
  CLIENT_SEARCH: ({ search, state } = {}) => ({
    pathname: "/clientSearch",
    search,
    state,
  }),
  CLIENT_MENU: ({ prefixedId } = {}) => `/client/${prefixedId}`,
  CLIENT_INFO: ({ prefixedId } = {}) => `/client/${prefixedId}/info`,
  CLIENT_SUPPORT_REQUEST: ({ prefixedId, search, state } = {}) => ({
    pathname: `/client/${prefixedId}/support-request`,
    search,
    state,
  }),
  ACQUIRING: ({ prefixedId, search, state } = {}) => ({
    pathname: `/client/${prefixedId}/acquiring`,
    search,
    state,
  }),
  EMISSION: ({ prefixedId, search, state } = {}) => ({
    pathname: `/client/${prefixedId}/emission`,
    search,
    state,
  }),
};



// WEBPACK FOOTER //
// ./src/model/subsystems/app/CONSTANTS.js